export const phoneRegExp = /^((\+){1}91){1}[1-9]{1}[0-9]{9}$|^((\+){1}1){1}[1-9]{1}[0-9]{9}$/
